import React from "react";
import {post} from "./common/utils/http";
import AisinoButton from "./baseComponent/button/AisinoButton";
import ArrowLeftOutlined from "@ant-design/icons/es/icons/ArrowLeftOutlined";
import AisinoRow from "./baseComponent/rowAndCol/AisinoRow";
import AisinoCol from "./baseComponent/rowAndCol/AisinoCol";

class ContactUs extends React.Component{
    state={
        container:''
    }
    componentDidMount() {
        post("aisino/portalIndex/getContactDetail",{},true)
            .then(response =>{
                this.setState({container:response.contactDetails});
            })
    }
    onCloseClick(){
        this.props.history.goBack();
    }
    render() {

        let rootButtonModules=[];
        return (
            <AisinoRow>
                <AisinoCol>
                    <AisinoButton onClick={() => this.onCloseClick()} icon={<ArrowLeftOutlined />}/>
                </AisinoCol>
                <AisinoCol>
                    <div className={"faq_detail"} dangerouslySetInnerHTML={{__html: this.state.container }}>
                    </div>
                </AisinoCol>
            </AisinoRow>
        );
    }
}
export default ContactUs;
